import { useDeletedSharePermanentlySubscription } from 'gqlTypes'
import { ErrorHandler } from 'modules/tracing'

import { handleShareDeletedPermanently } from '../handlers'
import { SubscriptionEventHandler } from './types'

export interface ShareDeletedPermanentlyPayload {
  shareIdentifier: string
  workspaceIdentifier: string
}

export interface UseShareDeletedPermanentlyProps {
  /**
   * handler which is called _before_ share is removed/added from/to the cache
   * it is possible to use this handler to update the UI state if it is
   * necessary
   */
  onDeletedSharePermanently?: SubscriptionEventHandler<ShareDeletedPermanentlyPayload>
}

export const useShareDeletedPermanently = (
  props: UseShareDeletedPermanentlyProps = {}
) => {
  const { onDeletedSharePermanently } = props

  useDeletedSharePermanentlySubscription({
    onSubscriptionData: ({ subscriptionData, client }) => {
      const payload = subscriptionData.data?.deletedSharePermanently

      if (!payload) {
        ErrorHandler.shouldNeverHappen(
          `missing useShareDeletedPermanently payload, ${JSON.stringify(
            subscriptionData
          )}`
        )
        return
      }

      const { workspaceIdentifier, shareIdentifier } = payload
      try {
        onDeletedSharePermanently?.({
          workspaceIdentifier,
          shareIdentifier,
          client,
        })
      } catch (e) {
        ErrorHandler.shouldNeverHappen(
          `onDeletedSharePermanently should not throw errors, ${JSON.stringify(
            e
          )}`
        )
      } finally {
        handleShareDeletedPermanently({
          cache: client,
          shareIdentifier: payload.shareIdentifier,
        })
      }
    },
  })
}
